<template>	
<v-container fluid class="py-0">
	<v-row cols="12">
		<v-col sm="12" md="6">
			<h3 class="mb-3">{{ trans('user.profile_contacts') }}</h3>
	
			<v-text-field 
			v-model="email" 
			:label="trans('user.email')" 
			:error="hasError('email')" 
			:error-messages="getError('email')"
			@input="unsetError('email')"
			outlined></v-text-field>

			<v-text-field 
			v-model="phone_number" 
			:label="trans('user.phone_number')"
			:error="hasError('phone_number')" 
			:error-messages="getError('phone_number')"
			@input="unsetError('phone_number')"
			outlined></v-text-field>

			<v-text-field 
			v-model="first_name" 
			:label="trans('user.first_name')" 
			:error="hasError('first_name')" 
			:error-messages="getError('first_name')"
			@input="unsetError('first_name')"
			outlined></v-text-field>

			<v-text-field 
			v-model="last_name" 
			:label="trans('user.last_name')" 
			:error="hasError('last_name')" 
			:error-messages="getError('last_name')"
			@input="unsetError('last_name')"
			outlined></v-text-field>

		</v-col>
		<v-col sm="12" md="6">
			
			<h3 class="mb-3">{{ trans('user.profile_privacy') }}</h3>

			<v-checkbox 
			v-model.number="email_visible" 
			:label="trans('user.email_visible')"
		    ></v-checkbox>

		    <v-checkbox 
		    v-model.number="phone_number_visible" 
		    :label="trans('user.phone_number_visible')"
		    ></v-checkbox>

		    <v-checkbox 
		    v-model.number="last_name_visible" 
		    :label="trans('user.last_name_visible')"
		    ></v-checkbox>
			
		</v-col>
	</v-row>
</v-container>
</template>

<script>
	
	import _ from 'lodash';
    import {mapGetters, mapActions, mapState} from 'vuex';
  

	export default {
		
	    data: () => ({
	    	phone_mask: '+############',
			// role	admin
			// locale	en
			// email	andrewdevelop@gmail.com
			// phone_number	null
			// first_name	null
			// last_name	null
			// email_visible	0
			// phone_number_visible	0
			// last_name_visible	0
			// email_verified	0
			// phone_number_verified	0
			// provider	password
			// locked_at	null
			// deleted_at	null
			// filled	false
			// activity	null
			buffer: {},
			saved: false,
	    }),

	    computed: {
            ...mapState('user', {
                store_instance: 'instance',
            }),
            ...mapGetters('user', {
            	isLoading: 'isLoading',
            }),
            ...mapGetters('errors', {
				getError: 'get',
				hasError: 'has',
            }),

            loading: function() {
            	return this.isLoading('load');
            },
            saving: function() {
            	return this.isLoading('store');
            },

            instance: {
            	get: function() {
            		if (this.store_instance) {
            			this.buffer = Object.assign({}, this.store_instance)
            		}
            		return this.buffer;
            	},
            	set: function(v) {
            		this.buffer = v;
            	}
            },
			email: {
				get: function() {
					return this.instance.email || null;
				},
				set: function(v) {
					this.instance.email = v;
				}
			},
			phone_number: {
				get: function() {
					return this.instance.phone_number || null;
				},
				set: function(v) {
					this.instance.phone_number = v;
				}
			},
			first_name: {
				get: function() {
					return this.instance.first_name || null;
				},
				set: function(v) {
					this.instance.first_name = v;
				}
			},
			last_name: {
				get: function() {
					return this.instance.last_name || null;
				},
				set: function(v) {
					this.instance.last_name = v;
				}
			},
			email_visible: {
				get: function() {
					return this.instance.email_visible || 0;
				},
				set: function(v) {
					this.instance.email_visible = !!v == true ? 1 : 0;
				}
			},
			phone_number_visible: {
				get: function() {
					return this.instance.phone_number_visible || 0;
				},
				set: function(v) {
					this.instance.phone_number_visible = !!v == true ? 1 : 0;
				}
			},
			last_name_visible: {
				get: function() {
					return this.instance.last_name_visible || 0;
				},
				set: function(v) {
					this.instance.last_name_visible = !!v == true ? 1 : 0;
				}
			},
			email_verified: {
				get: function() {
					return this.instance.email_verified || null;
				},
				set: function(v) {
					this.instance.email_verified = v;
				}
			},
			phone_number_verified: {
				get: function() {
					return this.instance.phone_number_verified || null;
				},
				set: function(v) {
					this.instance.phone_number_verified = v;
				}
			},
			provider: {
				get: function() {
					return this.instance.provider || null;
				},
				set: function(v) {
					this.instance.provider = v;
				}
			},
			is_fullfilled: function () {
				return this.email != null && this.phone_number != null && this.first_name != null && this.last_name != null;
			}
        },

        methods: {
            ...mapActions('user', {
                edit: 'edit',
                update: 'update'
            }),

            ...mapActions('errors', {
            	unsetError: 'unset',
            }),

            save: function() {
            	return this.update(this.buffer);
            },
        },

        mounted: function() {
        	this.edit();

        	this.$store.subscribe((mutation, state) => {
        		if (mutation.type == 'user/handleStatus' && state.status == 'saved') {
        			this.$emit('saved', state.status);
        		}
        	})
        }
	};

</script>